export default {
  apiBaseUrl: 'https://development-chloe-api.peoplescience.health/api/',
  socketUrl: 'https://development-chloe-api.peoplescience.health/',
  webUrl: 'https://development-chloe.peoplescience.health',
  appWebUrl: 'https://development-chloe-app.peoplescience.health',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  expires: 365,
  secure: true,
  referralUrl: 'https://development-chloe.peoplescience.health/referrals/',
  fitbitWebClientId: '238R5R',
  fitbitAppClientId: '23RDND',
  oAuthRedirectWebUri: 'https://development-chloe-app.peoplescience.health/*',
  oAuthRedirectAppUri:
    'health.peoplescience.chloe2.development://MyStudiesScreen',
  ouraAppClientId: '4K2SDUYK5FZY2ZXS',
  recaptchaSiteKey: '6LciVLYoAAAAAOpCrfDoYbh8dXyxN4ycIW30WDoZ',
  googleTagManagerId: 'GTM-TP4P4FQ'
};
